Realize.i18n.registerLocale({
	actions: {
		add: 'Add data in table',
		mobileAdd: 'Add',
		update: "Update",
		close: 'Close',
		back: 'Back',
		create: 'Create',
		confirm: 'Confirm',
		import: 'Import'
	},

	error: 'Error',
	by: 'by',
	overwrite: 'overwrite',
	warningExpandedGroup: 'Grupo não possui a opção "expandir e contrair grupo" configurada no Studio',
	groupWithoutField: 'Group does not have the field informed',
	warningEventSubscribeGroup: 'This event is not implemented for merge',

	erro: {
		button: {
			close: 'Close error message'
		}
	},

	masks: {
		cep: "99999-999",
		cnpj: "99.999.999/9999-99",
		cpf: "999.999.999-99",
		telefone: "(99) 9999-9999",
		celular: "(99) 9999[9]-9999",
		decimal: {
			alias: "decimal",
			groupSeparator: ",",
			radixPoint: ".",
			removeMaskOnSubmit: true,
			autoGroup: true,
			digitsOptional: false,
			integerDigits: 10,
			digits: 2,
			placeholder: "0",
			clearMaskOnLostFocus: false
		},
		currency: {
			alias: "currency",
			prefix: "$ ",
			groupSeparator: ",",
			radixPoint: ".",
			placeholder: "0",
			removeMaskOnSubmit: true,
			integerDigits: 10,
			digits: 2
		}
	},

	grid: {
		mathFuncitons: {
			operatorErrorType: "The column you want to calculate, needs to be of the Numeric, Decimal or Monetary type."
		}
	},

	datepicker: {
		monthsFull: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],
		monthsShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
		weekdaysFull: [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ],
		weekdaysShort: [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ],
		today: 'Today',
		clear: 'Clear',
		close: 'Close'
	},

	history: {
		title: 'History',
		activity: 'Activity',
		responsible: 'Responsible for activity',
		date: 'Date',
		by: 'by',
		in: 'in',
		show: "Show history",
		hide: "Hide history"
	},

	form: {
		validations: {
			required: 'This field is required.',
			fields_required: 'There are required fields to fill in'
		},
		errors: {
			error_default: 'Please check the error (s) below.',
			required_file_type: 'File type is a required field',
			unknown_error: 'Unexpected error.',
			null_pointer_exception: 'Unexpected error.',
			user_not_found: 'User not found. This was probably caused by the expiration of the user session, do a new login and try again.',
			activity_not_defined: 'The next activity was not defined.',
			action_to_assign_user_not_permited: 'You are not allowed to redirect this activity to another user. Only the process managers can perform this action.',
			user_route_not_informed: 'User for route not informed.',
			invalid_route: 'Invalid routing.',
			invalid_action_type: 'Invalid routing.',
			activity_executed: 'Activity was executed',
			sql_not_executed: 'An error occurred while executing SQL. Check the fields that are configured with the startup type as "Result of select" or in the "Result of select per page" setting.',
			invalid_environment_mode: 'Invalid access mode, switch to test or normal.',
			invalid_environment_mode_subprocess: 'The access mode (normal or test) between process and subprocess must be the same.',
			user_defined_not_exists: 'Informed routing invalid.',
			user_scaling_defined_not_exists: 'User defined scale does not exist',
			function_scaling_defined_not_exists: 'The defined role escalation does not exist',
			user_scaling_not_defined: 'User scale not defined',
			group_scaling_defined_not_exists: 'Defined group sizing does not exist',
			user_inactive_for_scaling: 'Inactive user for scaling',
			user_alternative_scaling_defined_not_exists: 'Alternate user scale defined does not exist',
			group_not_exist: 'Invalid group.',
			access_denied: 'The user does not have access permissions.',
			access_denied_for_activity_instance: 'The user does not have access permissions.',
			script_invalid: 'Could not determine the next activity in the script configured in this activity is not valid.',
			subprocess_referenced_not_configured: 'The call to the subprocess has not been configured correctly.',
			behavior: {
				event:{
					invalid_element: 'Load form behavior failure. Field invalid for event!'
				},
				action:{
					invalid_element: 'Load form behavior failure. Field invalid for action!'
				}
			},
			are_all_inputs_hidden: 'All fields are to be hidden or invisible.',
			process_definition_permition: 'Not allowed to open the process.',
			table_not_generated: 'Next instance table not generated.',
			process_has_been_canceled: 'The process has already been canceled.',
			integration_in_lock: 'There is an action in progress, refresh the page in a few moments to check the status of step',
			alternative_user_not_exist: 'Alternative user not exist',
			invalid_date: 'Invalid date',
			sub_process_non_actived: 'Failed to start the Subprocess, check with the Manager of this model if it is published (active).'
		},
		warnings: {
			max_length_numeric_api: 'Value @ exceeds the maximum allowed of'
		},
		messages: {
			info_required: '(*) Required fields.',
			info_warning_external_manipulation: '(!) Numeric/monetary field values exceeded maximum allowed size.'
		},
		errorExecuteAction: 'There was an error performing this action.',
		errorPossibleExecuteAction: 'Could not perform this action.',
		warnNotPropAPILabel: 'The label-type component does not contain this property in its structure.',
		invalid_text_value_size: 'The size of the field is not within the value accepted by the bank.'		
	},

	template: {
		defaultLabel: 'Template',
		titles: {
			create: 'Create Document',
			import: 'Import Document',
			attach: 'Attach Document',
			manage: 'Manage Document',
			detachOrDelete: 'Detach or Delete Document',
			detach: 'Detach Document',
			delete: 'Delete Document',
			handleDuplicate: 'Handle Duplicate Document',
			handleDivergentVersions: 'Divergent Versions',
			documentProperties: 'Document Properties',
			documentFields: 'Document Fields',
			fileData: 'File Data',
			digitalSignature: 'Digital Signature'
		},
		actions: {
			create: 'Create',
			import: 'Import',
			attach: 'Attach',
			manage: 'Manage',
			detach: 'Detach',
			delete: 'Delete',
			search: 'Search',
			onlyDetach: 'Only Detach',
			checkout: 'Check-out',
			cancelCheckout: 'Cancel edit',
			checkin: 'Check-in',
			overwrite: 'Overwrite',
			duplicate: 'Duplicate',
			downloadDocument: 'Download document',
			showGraph: 'Show graph',
			hideChart: 'Hide chart',
			selectVersion: 'Yes',
			notOverwrite: 'The selected document can not be overwritten because it was included through the process.',
			digitalSignature: 'Digital Signature',
			downloadDigitalSignature: 'Download Signature',
			sortAscText: 'Sort A - Z',
			sortDescText: 'Sort Z - A',
			sortAscNumber: 'Sort 1 - 9',
			sortDescNumber: 'Sort 9 - 1',
			previewDocument: 'View document'
		},
		messages: {
			processing: 'Processing',
			gridDetachModal: 'Unlink or delete actions will be performed immediately on the document cell in the grid.',
			detachOrDelete: 'Besides detaching, do you wish to delete this document as well?',
			detach: 'Are you sure that you want to detach this document?',
			delete: 'Are you sure that you want to delete this document?',
			documentReadonly: 'File locked for edition.',
			documentLockedForCheckout: 'This document can\'t be opened for editing at this time.',
			handleDuplicate: 'Does this document already exist, do you want to overwrite it or create a new duplicate?',
			handleDivergentVersions: 'The current file can not be edited because a new version exists. Do you want to select the latest version of the file to edit?',
			handleCheckoutUndone: 'The checkin cannot be executed, or the current file has no lock for editing.',
			file_type_restriction_exception: 'Could not update document with type restricted. Only .pdf file is allowed.',
			profile_can_not_edit_document: 'You do not have permission to perform this action on the template',
			licenseECM: 'Option not available for the current ECM license type.',
			allowedFileTypes: 'Could not upload document. File only. @@type@@ is allowed.',
			allowedFileTypesSize: 'Could not upload document. Only file @@type@@ and size ##size## are allowed.',
			maxFileSizeAllowed: 'Could not perform document uploado. For the size of the file ##size## is larger than allowed.',
			noDigitalSign: 'Lecom signer not found. If it has already been installed, contact support.',
			connectingDigitalSignService: 'Connecting subscription service. Wait...',
			waitingForTheSignedDocument: 'Waiting for signed document...',
			documentUploadedSignature: 'Document signed successfully.',
			canceledDigitalSignature: 'The document signature has been canceled.',
			signatureFailure: 'Document signature failed.',
			notPermssionDigitalSign: 'You do not have permission to subscribe!',
			errorCompatibility: 'The signed version of Lecom is outdated. Please upgrade.',
			errorDigitalSignature: 'Error connecting to the subscriber. If the problem persists, contact support.'
		},
		attributes: {
			file: 'File',
			fileType: 'File Type',
			fileName: 'File',
			author: 'Author',
			version: 'Version',
			currentVersion: 'Current version',
			createdAt: 'Created At'
		}
	},

	processInstance: {
		status: 'Status',
		code: 'Code'
	},

	modal : {
		loading: 'Processing...',
		lupa: {
			warningSelectLupa: 'Failed to run filter. Check the model settings.'
		}
	},

	process: {
		description: "Process description",
		helpText: 'Help',
		helpModalTitle: 'Information',
		assignToUserModelTitle: 'Redirect',
		actions: {
			cancel: 'Cancel',
			finish: 'Finish'
		},
		messages: {
			processFinished: 'Process finished'
		},
		status: {
			COMPLETED: 'APPROVED',
			REJECTED: 'REJECTED'
		},
		helpTitle: 'Process help',
		helpDesc: 'Description',
		helpDescEmpty: 'No description',
		helpTextModal: 'Help text',
		helpTextEmpty: 'No help text',
		helpFile: 'File',
		helpFileDownload: 'Download help file',
		helpFileEmpty: 'No files'
	},

	activity: {
		cycle: 'Cycle',
		due_date: 'Deadline',
		start_date: 'Started at',
		finish_date: 'Finish at',
		actions: {
			approve: 'Approve',
			reject: 'Reject',
			openLookup: 'Open Lookup'
		},
		toolbox: {
			toolboxName: "Action",
			saveActivity: 'Save',
			cancelProcess: 'Cancel Process',
			markActivityAsUnread: 'Mark as unread',
			downloadProcessHelpFile: 'Help file',
			assignToUser: 'Assign to another user',
			openTimeLine: 'Open timeline',
			printForm: 'Print',
			openProcessHelpModal: "Help",
			openAssignActivityToUserModal: "Assign activity"
		},
		assignToUserModal: {
			selectUser: 'Select a user for redirection',
			selectUserWarning: 'Before confirming the redirect, select a user!'
		},
		messages: {
			nextActivity: 'Next activity',
			nextResponsibles: 'Next responsibles',
			activityFinished: 'Activity saved successfully',
			activityCancelled: 'Activity was cancelled successfully!',
			multipleApprovalFailed: "Couldn't perform the automatic approval, because the activity doesn't allow approval!",
			multipleRejectionFailed: "Couldn't perform the automatic rejection, because the activity doesn't allow rejection!",
			integration: "Integration",
			executed: "executed",
			concentratorActivity: 'Concentrator Activity',
			concentratorActivityWithPendingActivities: 'This is a concentrating step, and will be released when all parallel steps are completed.',
			activityBlocked: 'Blocked Activity',
			finalActivity: 'Final Activity',
			subProcess: 'A new instance of the process has been opened: Code'
		},
		status: {
			CANCELLED: 'Cancelled',
			IN_PROGRESS: 'In Progress',
			APPROVED: 'Approved',
			REJECTED: 'Rejected',
			EXCLUDED: 'Removed',
			HIBERNATED: 'Hibernated',
			HIBERNATING: 'Hibernating',
			LATE: 'Late',
			FINALIZED: 'Finalized',
			OPENING: 'Opening',
			SCHEDULED: 'Scaled',
		}
	},

	successResponseMessages: {
		saveActivity: 'The activity data were successfully saved.',
		cancelProcess: 'The process was successfully cancelled.',
		markActivityAsUnread: 'The activity was marked as unread successfully.',
		assignActivityToUser: 'Activity redirected successfully. User responsible for the next activity:',
		assignActivityToUserTitle: 'Activity redirected successfully!'
	},

	confirmMessages: {
		cancelProcess: 'Are you sure that you want to cancel this process? This action is irreversible.'
	},

	javascript: {
		errors: {
			noLoad: "Failed to load custom script defined in this step."
		}
	},

	table: {
		columnActions: 'Actions',
		emptyResult: 'No data added',
		emptyResultSearcher: 'No data found'
	},

	general: {
		date: {
			format_date: 'Fill in the format',
			format: 'day, month and year',
			invalid: 'It is not valid',
		},
		button: {
			edit: 'Edit',
			delete: 'Delete',
			download: 'Download',
			help_modal: 'Modal help button'
		},
		description:{
			refresh: 'Refresh - Press the enter key to load an automatic value.',
			date: 'Date - Press the enter key to open the date selection mode.',
			magnifying_glass: 'Magnifying glass - Press the enter key to access the modal and perform a search.'
		},
		textarea: {
			maxlength: 'Number of characters typed is @ at most #.'
		},
		error: {
			close: 'Close error message.'
		},
		new_document: 'Create a new document.',
		not_attached_document: 'Import a new document.',
		attach_document: 'Attach a new document.',
		document_create: '@ Was created.',
		attach_document_form: 'The @ document was attached to the form.',
		group_label: 'Hide or show form content - the current state is @',
		close: 'closed',
		open: 'open',
		select: 'Select',
		open_options: 'Press Space to open the options @',
		options_selected: 'Selected option @',
		not_options_selected: 'Neither a selected option',
		search: {
			options: '@ focused option, # of & results available. Use Tab to go to the next option or Tab + shift to return to the previous option, press Enter to select the currently focused option, press Esc to exit the menu.'
		},
		empty_result_list: 'No items were found.',
		show_help_text: 'Press Enter to open help mode.',
		filter_to: 'Search for @ or go to list using the tab or the directional down'
	}

}, 'en');
